// extracted by mini-css-extract-plugin
export default {"links":"styles_links__HRLo4","link":"styles_link__bdEcG","active":"styles_active__JMSHs","icon":"styles_icon__IkT2B"};